/* eslint-disable react/forbid-prop-types */
import React, {memo} from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../../../../../util/utils';
import ControlsList from './ControlsList';
import {controlType} from '../../../../../../../../../util/uiconstants';
import PropTypes from 'prop-types';

export const ControlsContainer = ({controls, className, hideEmptySections, documentId, bodyId}) => {
	const applicationControls = controls.filter((control) => {
		return control.controlTypeId === controlType.itApplicationControl;
	});

	const itdmControls = controls.filter((control) => {
		return control.controlTypeId === controlType.itDependentManualControl;
	});

	return (
		<section className={className}>
			{hideEmptySections && applicationControls.length === 0 ? null : (
				<ControlsList
					key="applications"
					documentId={documentId}
					bodyId={bodyId}
					controls={applicationControls}
					title={labels.applicationControl}
					placeholderText={labels.noAapplicationControlAvailable}
				/>
			)}
			{hideEmptySections && itdmControls.length === 0 ? null : (
				<ControlsList
					key="itdm"
					documentId={documentId}
					bodyId={bodyId}
					controls={itdmControls}
					title={labels.iTDependentManualControl}
					placeholderText={labels.noITDependentManualControlAvailable}
				/>
			)}
		</section>
	);
};

ControlsContainer.displayName = 'ControlsContainer';

ControlsContainer.propTypes = {
	controls: PropTypes.array.isRequired,
	onNameClick: PropTypes.func,
	className: PropTypes.string,
	hideEmptySections: PropTypes.bool
};

const StyledControlsContainer = styled(ControlsContainer)``;

export default memo(StyledControlsContainer);
1;
